import { useEffect, useState } from "react";
import Backdrop from "../../layouts/Backdrop/Backdrop";
import popup from "./Popup.module.css";
import { PopUpPilihEntity } from "./PopupPilihEntity";
import FilterUtils from "../../utils/filter-utils";
import { IoClose } from "react-icons/io5";

export default function PopupPilih(props: { showPopup: boolean, setShowPopup: ((val: boolean) => void), popUpPilihEntity: PopUpPilihEntity }) {
    const {
        showPopup,
        setShowPopup,
        popUpPilihEntity
    } = props;

    const popupTitle = popUpPilihEntity.popupTitle;
    const tableContent = popUpPilihEntity.tableContent;
    const onClick = popUpPilihEntity.onClick;
    const onClose = popUpPilihEntity.onClose;

    const [tableDataFilter, setTableDataFilter] = useState<{ [key: string]: string }>({});

    const click = (row: any) => {
        setShowPopup(false);
        setTableDataFilter({});
        onClick(row);
    }

    const close = () => {
        setShowPopup(false);
        setTableDataFilter({});
        onClose();
    }

    useEffect(() => {
        if (tableContent == null || tableContent.length == 0) return;
        let start: { [key: string]: string } = {}
        const keys = Object.keys(tableContent[0]);
        for (let i = 0; i < keys.length; i++) {
            start[keys[i]] = '';
        }
        setTableDataFilter(start);
    }, [])

    return (
        <>
            {showPopup && <Backdrop close={() => close()} />}
            <div className={popup.modalmobile} id={showPopup ? null : popup.hide} style={{ maxWidth: '1200px', padding: '1.5vw 4vw 2.5vw 4vw' }}>
                <div className={popup.headerTitlePopupPilih}>
                    <h2>{popupTitle.replace("_", " ") ?? ''}</h2>

                    <button onClick={() => close()}>
                        <IoClose strokeWidth={20} />
                    </button>
                </div>

                <div>
                    {tableContent.length == 0
                        ? <table><thead><tr><th>no data available yet!</th></tr></thead></table>
                        : <>
                            <div style={{ maxHeight: "70vh", overflow: "auto" }}>
                                <table className="tablepopup">
                                    <thead>
                                        <tr>
                                            {Object.keys(tableContent[0]).map((key) => {
                                                return <th key={`filter-${key}`}>
                                                    <label style={{ fontSize: "12px", textTransform: 'uppercase', fontWeight: '600', color: "white" }}>{key.replace('_', ' ')} :</label>
                                                    <input
                                                        type="text"
                                                        id={`${key}`}
                                                        name={key}
                                                        value={tableDataFilter[key]}
                                                        onChange={(event) => setTableDataFilter(prevState => ({
                                                            ...prevState,
                                                            [event.target.name]: event.target.value
                                                        }))}
                                                    />
                                                </th>
                                            })}
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {tableContent
                                            .filter((row) => {
                                                return FilterUtils.FilterTable(row, tableDataFilter)
                                            })
                                            .map((row, index) => {
                                                return <tr key={`rowSelectTable-${index}`} onClick={() => click(row)}>
                                                    {Object.keys(row).map((key) => {
                                                        return <td key={`${index}-key${key}`}>{row[key]}</td>
                                                    })}
                                                </tr>
                                            })}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    }
                </div>
            </div>
        </>
    );
}
